@if (hasFieldLayout) {
  <lm-form-layout
    [specFields]="specFields"
    [layout]="fieldLayout"
    [model]="model"
    [placeHolder]="placeHolder"
    [layoutInfo]="layoutInfo"
    (fieldEvent)="onFieldEvent($event)"
  ></lm-form-layout>
}

@if (isCreateReportMode) {
  <lm-report-field-picker-button [field]="field" [model]="model" [specFields]="specFields"></lm-report-field-picker-button>
}

@switch (layoutType) {
  @case (layoutEnum.PROGRESS) {
    <lm-progress
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-progress>
  }
  @case (layoutEnum.RATING) {
    <lm-rating
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [model]="model"
      [specFields]="specFields"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-rating>
  }
  @case (layoutEnum.BINARY_DOCUMENT) {
    <lm-fileupload
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-fileupload>
  }
  @case (layoutEnum.CHECKBOX) {
    <lm-checkbox
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-checkbox>
  }
  @case (layoutEnum.CHECKBOXGROUP) {
    <lm-checkboxgroup
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)">
    ></lm-checkboxgroup>
  }
  @case (layoutEnum.PASSWORD) {
    <lm-text
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-text>
  }
  @case (layoutEnum.DATE) {
    <lm-date
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-date>
  }
  @case (layoutEnum.TIME) {
    <lm-time
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-time>
  }
  @case (layoutEnum.RADIO) {
    <lm-radiobutton
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-radiobutton>
  }
  @case (layoutEnum.DROPDOWN) {
    <lm-dropdown
      [layoutObject]="field"
      [mutexSpecField]="mutexSpecField"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-dropdown>
  }
  @case (layoutEnum.MULTI_SELECT) {
    <lm-dropdown
      [layoutObject]="field"
      [mutexSpecField]="mutexSpecField"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-dropdown>
  }
  @case (layoutEnum.ONE_LINE_TEXTAREA) {
    <lm-text
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-text>
  }
  @case (layoutEnum.PROCESS_INDICATOR) {
    <lm-process-indicator
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [specFields]="specFields"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-process-indicator>
  }
  @case (layoutEnum.MULTI_LINE_TEXTAREA) {
    <lm-textarea
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-textarea>
  }
  @case (layoutEnum.FIELD_EDITOR) {
    <lm-field-editor
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-field-editor>
  }
  @case (layoutEnum.FIELD_EDITOR_COMPARE) {
    <lm-field-editor-compare
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-field-editor-compare>
  }
  @case (layoutEnum.BUSCLASS_FIELD) {
    <lm-busclassfield
      [layoutObject]="field"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-busclassfield>
  }
  @case (layoutEnum.RICH_TEXT) {
    <lm-richtext
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [parentIsFormLayout]="parentIsFormLayout"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
    ></lm-richtext>
  }
  @case (layoutEnum.LOOKUP) {
    <lm-lookup
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-lookup>
  }
  @case (layoutEnum.TEXT) {
    <lm-text
      #Field
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-text>
  }
  @case (layoutEnum.IMAGE) {
    <lm-image
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      class="field"
    ></lm-image>
  }
  @case (layoutEnum.MANUAL_REPRESENTATION) {
    <lm-manual-representation
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      class="field"
    ></lm-manual-representation>
  }
  @case (layoutEnum.COMPACT_FORMAT) {
    <lm-text
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-text>
  }
  @case (layoutEnum.COMPACT_FORMAT_BY_FORM) {
    <lm-compound-field
      [layoutObject]="field"
      [layoutInfo]="layoutInfo"
      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
      [specFields]="specFields"
      [placeHolder]="placeHolder"
      [model]="model"
      [previewMode]="field?.previewMode"
      class="field"
      (fieldEvent)="onFieldEvent($event)"
      (errorOnMemberField)="onMemberFieldError($event)"
    ></lm-compound-field>
  }
  @case (layoutEnum.CAPTCHA_CONTROL) {
    <lm-captcha-control>
    </lm-captcha-control>
  }
}
